export default "__VITE_ASSET__CXSSb73q__"